import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { registerRequest } from "../api/auth.api";
import './Register.css';

const Register = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        nom: "",
        prenom: "",
        email: "",
        mobile: "",  
        Mp: "",
        confirmPassword: ""
    });
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleRegister = async (e) => {
        e.preventDefault();

        if (!formData.nom || !formData.prenom || !formData.email || !formData.Mp || !formData.confirmPassword) {
            toast.error("Veuillez remplir tous les champs");
            return;
        }

        if (formData.Mp !== formData.confirmPassword) {
            toast.error("Les mots de passe ne correspondent pas");
            return;
        }

        if (formData.Mp.length < 6) {
            toast.error("Le mot de passe doit contenir au moins 6 caractères");
            return;
        }

        if (!/[A-Z]/.test(formData.Mp)) {
            toast.error("Le mot de passe doit contenir au moins une majuscule");
            return;
        }

        if (!/[a-z]/.test(formData.Mp)) {
            toast.error("Le mot de passe doit contenir au moins une minuscule");
            return;
        }

        if (!/[0-9]/.test(formData.Mp)) {
            toast.error("Le mot de passe doit contenir au moins un chiffre");
            return;
        }

        if (!/[^A-Za-z0-9]/.test(formData.Mp)) {
            toast.error("Le mot de passe doit contenir au moins un caractère spécial");
            return;
        }

        setLoading(true);

        try {
            await registerRequest({
                prenom: formData.prenom,
                nom: formData.nom,
                email: formData.email,
                mobile: formData.mobile || "00000000", 
                Mp: formData.Mp
            });
            
            toast.success("Inscription réussie ! Redirection vers la page de connexion...");

            setTimeout(() => {
                navigate('/login');
            }, 2000);

        } catch (err) {
            console.error("Erreur inscription:", err);
            toast.error(err.message || "Une erreur est survenue lors de l'inscription");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Toaster position="top-right" richColors />
            <div className="register-container">
                <div className="register-card">
                    <div className="register-header">
                        <div className="register-icon-wrapper">
                            <svg className="register-svg-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                            </svg>
                        </div>
                        <h1 className="register-title">Créer un compte</h1>
                        <p className="register-description">Rejoignez-nous dès aujourd'hui</p>
                    </div>

                    <div className="register-content">
                        <form onSubmit={handleRegister} className="register-form">
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="nom" className="form-label">Nom</label>
                                    <input
                                        id="nom"
                                        name="nom"
                                        type="text"
                                        value={formData.nom}
                                        onChange={handleChange}
                                        className="form-input"
                                        placeholder="Entrez votre nom"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="prenom" className="form-label">Prénom</label>
                                    <input
                                        id="prenom"
                                        name="prenom"
                                        type="text"
                                        value={formData.prenom}
                                        onChange={handleChange}
                                        className="form-input"
                                        placeholder="Entrez votre prénom"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="form-input"
                                    placeholder="exemple@email.com"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="mobile" className="form-label">Téléphone (optionnel)</label>
                                <input
                                    id="mobile"
                                    name="mobile"
                                    type="tel"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    className="form-input"
                                    placeholder="12345678"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="Mp" className="form-label">
                                    Mot de passe
                                    <span className="password-hint"> (min 6 caractères, 1 majuscule, 1 chiffre, 1 spécial)</span>
                                </label>
                                <div className="password-wrapper">
                                    <input
                                        id="Mp"
                                        name="Mp"
                                        type={showPassword ? "text" : "password"}
                                        value={formData.Mp}
                                        onChange={handleChange}
                                        className="form-input password-input"
                                        placeholder="••••••••"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="password-toggle-btn"
                                    >
                                        <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                    </button>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="confirmPassword" className="form-label">Confirmer le mot de passe</label>
                                <div className="password-wrapper">
                                    <input
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        type={showConfirmPassword ? "text" : "password"}
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        className="form-input password-input"
                                        placeholder="••••••••"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        className="password-toggle-btn"
                                    >
                                        <i className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                    </button>
                                </div>
                            </div>

                            <button 
                                type="submit" 
                                disabled={loading} 
                                className="submit-btn"
                            >
                                {loading ? "Inscription en cours..." : "S'inscrire"}
                            </button>

                            <div className="register-footer">
                                <p className="footer-text">
                                    Vous avez déjà un compte ?{" "}
                                    <Link to="/login" className="login-link">
                                        Se connecter
                                    </Link>
                                </p>
                                <Link to="/" className="home-link">
                                    <i className="fas fa-home"></i>
                                    Retour à l'accueil
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Register;